import { isAxiosError } from 'axios';
import { ZodError } from 'zod';

import { getHttpStatus, getQcsErrorCode } from 'app-components/utils/core';

import type { WellnessScoreRequestError } from './wellnessScoreTypes';

export const toWellnessScoreRequestError = (error: unknown): WellnessScoreRequestError => {
  if (error instanceof ZodError) {
    return {
      kind: 'schema',
      message: 'Invalid wellness score response',
      issues: error.issues.map(({ path, code, message }) => ({ path, code, message })),
    };
  }
  const status = getHttpStatus(error);
  if (status !== undefined) {
    return {
      kind: 'http',
      message: error instanceof Error ? error.message : `Request failed with status code ${status}`,
      status,
      qcsCode: getQcsErrorCode(error) ?? null,
    };
  }
  if (isAxiosError(error)) {
    return { kind: 'transport', message: error.message, code: error.code ?? null };
  }
  return {
    kind: 'unknown',
    message: error instanceof Error ? error.message : 'Failed to fetch wellness score',
  };
};
